import { render, staticRenderFns } from "./CompanyUsersTable.vue?vue&type=template&id=065470c4&scoped=true"
import script from "./CompanyUsersTable.vue?vue&type=script&lang=js"
export * from "./CompanyUsersTable.vue?vue&type=script&lang=js"
import style0 from "./CompanyUsersTable.vue?vue&type=style&index=0&id=065470c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065470c4",
  null
  
)

export default component.exports